
import state from './state';
import Store from '../base';


export default class ActionLogEntries extends Store {
    constructor(model, ng){

        state.model = model;

        super({state, ng});
    }
}



// WEBPACK FOOTER //
// ./src/app/store/action_log/index.js